import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class GetCarrierIntegrationsSignalCommand extends IRequestCommand<
  IGetCarrierIntegrationsSignalResponse,
  ErrorDetails,
  IGetCarrierIntegrationsSignalParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'api/carrier/{carrierUserId}/paginated';

  public override setParameters(parameters: IGetCarrierIntegrationsSignalParameters) {
    this._commandUrl = this._commandUrl.replace('{carrierUserId}', parameters.carrierUserId.toString());
    const params: string[] = [
      `page=${parameters.page}`,
      `size=${parameters.size}`,
      `column=${parameters.column ?? ''}`,
      `sort=${parameters.sort ?? 'DESC'}`,
      `magiisApi=false`,
      `find2=${parameters.find2 ?? 'AutoRespoder.SG'}`
    ];
    if (parameters.find1 != null) {
      params.push(`find1=${parameters.find1}`);
    }
    this._commandUrl += '?' + params.join('&');
  }
}

export interface IGetCarrierIntegrationsSignalParameters extends ICommandParameters {
  carrierUserId: string;
  page: number;
  size: number;
  column?: string;
  sort?: string;
  find1?: string | null;
  find2?: string;
}

export interface SignalIntegrationItem {
  id: number;
  applicationName: string;
  roleName: string;
  enabled: boolean;
  blocked: boolean | null;
  creationDate: string;
  serviceName: string;
  lastRequest: string;
  currentQty: number;
  limit: number;
  remaining: number;
  recordType: string;
  serviceId: number | null;
}

export interface IGetCarrierIntegrationsSignalResponse extends ICommandResponse {
  content: SignalIntegrationItem[];
  size: number;
  totalElements: number;
  totalPages: number;
}
